import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PagesRoutingModule } from './pages-routing.module';
import {SettingComponent} from './setting/setting.component';
import {NzPopconfirmModule} from 'ng-zorro-antd/popconfirm';
import {CurrencyModule} from './currency/currency.module';
import {MembersModule} from './members/members.module';
import {GeneralSettingModule} from './general-setting/general-setting.module';

@NgModule({
    imports: [
        SharedModule,
        PagesRoutingModule,
        NzPopconfirmModule,
        ReactiveFormsModule,
        CurrencyModule,
        MembersModule,
        GeneralSettingModule
    ],
    declarations: [
        SettingComponent,
    ],
    providers: []
})

export class PagesModule {}
